import type { Theme } from '@mui/material';

export const styles = {
  searchFieldWrapper: (theme: Theme) => ({
    [theme.breakpoints.up('sm')]: {
      minWidth: '18.75rem',
      flexGrow: 1,
    },
    pt: 2,
    pb: 1,
  }),

  dataGridContainer: {
    height: '100%',
  },

  filtersContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },

  dataGridWrapper: (theme: Theme) => ({
    overflowY: 'auto',
    height: '100%',
    boxShadow: '0px 4px 23px 0px #00000014',
    border: '1px solid',
    borderColor: theme.colors.neutral[100],
  }),

  dataGrid: (theme: Theme) => ({
    '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: 'background.selected',
    },
    '& .MuiDataGrid-container--top [role="row"]': {
      backgroundColor: theme.colors.neutral[50],
      maxHeight: '48px',
    },
    '& .hideRightSeparator > .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeader': {
      maxHeight: '48px',
      p: 0,
      fontFamily: 'Inter',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '18px',
    },
    '& .MuiDataGrid-cell': {
      p: 0,
      color: theme.colors.neutral[500],
      alignContent: 'center',
    },
    '.MuiDataGrid-iconButtonContainer': {
      visibility: 'visible',
      pt: 1.25,
    },
    '.MuiDataGrid-sortIcon': {
      opacity: 'inherit !important',
    },
    '.MuiDataGrid-columnHeaderTitleContainerContent': {
      display: 'flex',
      padding: '16px 0px 8px 0px',
      alignItems: 'center',
      gap: '8px',
    },
  }),
};
